"use client";

import NavSearchTrigger from "@/components/nav/NavSearchTrigger";
import { cn } from "@/lib/utils";

/**
 * Search in the navy top bar: a white field beside the studio's mark, the one
 * thing on the bar that looks typeable. While search is `open` the field
 * becomes the input, in the same place: the pane renders it into the slot
 * here (`inputSlotRef`) and its results open beside the rail below.
 * `buttonRef` reaches the trigger, for the shortcut tour and for focus to
 * return to when the search is dismissed.
 */
export default function NavSearchRow({ open, buttonRef, inputSlotRef, onOpen }) {
  return (
    <div className="flex min-w-0 max-w-sm flex-1">
      {!open && <NavSearchTrigger buttonRef={buttonRef} onClick={onOpen} />}
      <div ref={inputSlotRef} className={cn("w-full", !open && "hidden")} />
    </div>
  );
}
